export enum EntityStoreKey {
  Tags = 'tags',
  Sources = 'sources',
  OfferTags = 'offerTags',
}

export enum AttrDataScope {
  Table = 'table',
  Search = 'search',
  Typeahead = 'typeahead',
  Widget = 'widget',
}
